
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Image } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Erika wird zum dritten Mal besamt. Das klappt aber nur noch nach dem vierten Versuch.
Ihre Fruchtbarkeit nimmt ab. Sie gibt dafür umso mehr Milch: Nach dem dritten Kalb
sind es bis zu 40 Liter am Tag. Auf Erikas Hof kommt ein vom Kanton beauftragter
Kontrolleur vorbei. Wenn er Mängel findet, wird eine Kürzung der Direktzahlung
veranlasst. Stösst er auf gravierende Verstösse gegen das Tierwohl, macht er
eine Meldung an den Kantonstierarzt. Darauf folgen weitere Kontrollen, im
Extremfall sogar eine Strafanzeige bei der Staatsanwaltschaft. Im Kanton St. Gallen
kam es 2018 zu 253 Inspektionen von Mitarbeitern des Kantonstierarztes. Mängel fanden
sie bei 175 Kontrollen (69 Prozent). Es kam zu 45 Strafanzeigen, also bei jedem fünften kontrollierten Hof.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;